export const ORDER_STATUS_TYPES = {
  视频制作中: 0,
  文案确认中: 1,
  审核中: 2,
  资料修改中: 3,
  工作流待开始: 4,
  工作流进行中: 5,
  工作流已完成: 6,
  工作流失败: 7,
  已完成: 8,
  未提交: 9,
};

export const ORDER_STATUS_TYPES_MAP = {
  0: '视频制作中',
  1: '文案确认中',
  2: '审核中',
  3: '资料修改中',
  4: '工作流待开始',
  5: '工作流进行中',
  6: '工作流已完成',
  7: '工作流失败',
  8: '已完成',
  9: '未提交',
};

export const VIDEO_TYPES = {
  数字音容版: '数字音容版',
  数字音容Plus: '数字音容Plus',
  AI念影版: 'AI念影版',
  AI灵犀版: 'AI灵犀版',
  AI拾忆版: 'AI拾忆版',
  AI惜别版: 'AI惜别版',
  AI寻梦版: 'AI寻梦版',
  电影级定制: '电影级定制',
  数字音容版25年版本: '数字音容版(25年版本，即将下线)',
  数字音容Plus25年版本: '数字音容Plus(25年版本，即将下线)',
  AI念影版25年版本: 'AI念影版(25年版本，即将下线)',
  AI灵犀版25年版本: 'AI灵犀版(25年版本，即将下线)',
  AI拾忆版25年版本: 'AI拾忆版(25年版本，即将下线)',
  AI惜别版25年版本: 'AI惜别版(25年版本，即将下线)',
  AI寻梦版25年版本: 'AI寻梦版(25年版本，即将下线)',
};

export const MODAL_TYPES = {
  提交失败: '提交失败',
  管理员修改文案: '管理员修改文案',
  请再次确认文案: '请再次确认文案',
  请选择自动化流程: '请选择自动化流程',
  确认完结订单: '确认完结订单',
  确认删除订单: '确认删除订单',
  存在正在进行的工作流: '存在正在进行的工作流',
  人员分配: '人员分配',
  确认审核通过: '确认审核通过',
  确认审核不通过: '确认审核不通过',
  无权限: '无权限',
  订单创建失败: '订单创建失败',
  订单提交失败: '订单提交失败',
  验证失败: '验证失败',
};

export const ISARCHIVE_TYPES = {
  归档: true,
  未归档: false,
};

export const AUTOMATION_TASKS_TYPES = {
  未执行: 0,
  正在执行: 1,
  全部成功: 2,
  部分成功: 3,
  失败: 4,
};

export const STATIC_AI_STATUS_TYPES = {
  未执行: 'not started',
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  SUSPENDED: 'SUSPENDED',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
  UNKNOWN: 'UNKNOWN',
};

export const KLING_STATUS_TYPES = {
  NOTSTARTED: '"not started"',
  SUBMITTED: 'submitted',
  PROCESSING: 'processing',
  SUCCEED: 'succeed',
  FAILED: 'failed',
};

export const IMAGE_PROCESSING_STATUS_TYPES = {
  VALIDATED: 'VALIDATED',
  UPLOADING: 'UPLOADING',
  FAILED: 'FAILED',
  SUCCEED: 'SUCCEED',
};

export const UPLOAD_OR_REPLACE_TYPES = {
  upload: 'upload',
  replace: 'replace',
};

export const ALL_TABLE_TYPES = {
  clients: 'clients',
  image: 'images',
  audio: 'audios',
};

export const TABLE_FIELD_TYPES = {
  audio_text: 'audio_text',
  image_description: 'image_description',
};

export const ROLE_TYPES = {
  管理员: 1,
  制作人员: 2,
  客服: 3,
};

export const GENDER_TYPES = {
  男: 0,
  女: 1,
};

export const AUDIO_TYPES = {
  DECEASED: 'deceased_audio',
  NARRATOR: 'narrator_audio',
};

export const TEXT_TYPE = {
  SPEECH: 1,
  FAREWELL: 2,
};

export const DASHBOARD_TIME_FILTER_TYPE = {
  ALL: '累计',
  MONTH: '本月',
  YEAR: '本年',
  CUSTOM: '自定义',
};

export const DASHBOARD_TREND_FILTER_TYPE = {
  ORDER_TYPE: '订单套餐',
  ORDER_STATUS: '订单状态',
  ORDER_REVENUE: '订单收入',
};

export const DASHBOARD_PIE_FILTER_TYPES = {
  ORDER: '订单',
  REVENUE: '营收',
};

export const BUSINESS_LINE_TYPES = {
  公墓: '公墓',
  殡仪: '殡仪',
};

export const REGION_TYPES = {
  上海: '上海',
  中部: '中部',
  安徽: '安徽',
  西部: '西部',
  北方: '北方',
  南方: '南方',
};


export const PERSON_TYPES = {
  FIRST_PERSON: '第一人称',
  THIRD_PERSON: '第三人称',
};

export const DIGITAL_HUMAN_TYPES = {
  WAVE: '数字人挥手告别',
  ORIGINAL_VOICE: '数字人原声复刻告别',
  FAREWELL: '数字人告别',
};

export const VOICE_REPRODUCTION_TYPES = {
  FAMILY_AND_AI: '亲属原声复刻/AI专业主播讲述',
  AI_ONLY: 'AI专业主播讲述',
};
